module.exports = __webpack_public_path__ + "img/login_logo.61e4a59c.png";